import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import InfoPanelButtonLayout from "./InfoPanelButtonLayout";

export default class InfoPanelView extends AbstractView {

    constructor(target, languagePack, gameAssets) {
        super(target);
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;

        this._panel = this._target.contents;
        this._toggle = this.createButton(this._panel.toggle, this._handleToggle.bind(this));

        this._panel.titleTextfield.text = this.getText("info.title");

        this._pageIds = [];
        for (let i = 0; i < 99; i++) {
            const id = "info.page" + (i + 1);
            const txt = this.getText(id + ".title");
            if (isNull(txt)) {
                break;
            }
            this._pageIds.push(id);
        }

        this._buttonPrev = this.createButton(this._panel.prevButton, this._handlePrev.bind(this), this.getText("infopanel.button.previous"));
        this._buttonNext = this.createButton(this._panel.nextButton, this._handleNext.bind(this), this.getText("infopanel.button.next"));

        this._pageButtons = [];
        //create character buttons (pageButton1 etc)
        for (let i = 0; i < this._pageIds.length; i++) {
            const button = this.createButton(this._panel["pageButton" + (i + 1)], this._handlePageButton.bind(this));
            button.index = i;
            this._pageButtons.push(button);
        }

        this._buttonLayout = new InfoPanelButtonLayout(this._pageButtons);

        //block clicks through panel, quick and dirty
        this._target.bg.addEventListener("click", () => { });

        this._animating = false;
        this._openY = 0;
        this._closeY = target.contents.y;
        this._panel.y = this._closeY;
        this._toggle.setSelected(true);

        this._forcingReadAll = false;

        this.close(true);

        this.setPage(0);
    }

    set enabled(value) {
        this._toggle.setEnabled(value);
    }

    forceReadAll() {
        this.enabled = false;
        this._forcingReadAll = true;
        this._allRead = false;
        this.scheduleNudge();
    }

    stopNudges() {
        this.killDelayedCall(this._nudgeTimeout);
        if (this._nudgeTarget) {
            createjs.Tween.removeTweens(this._nudgeTarget);
            this._nudgeTarget.alpha = 1;
            this._nudgeTarget = null;
        }
    }

    scheduleNudge(delay = 6000) {
        this._nudgeTimeout = this.callDelayed(this.nudge.bind(this), delay / AppModel.speedFactor);
    }

    nudge() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._allRead ? this._panel.toggle : this._panel.nextButton
        this.blink(this._nudgeTarget, 3);
        this.scheduleNudge(8500);
    }

    blink(target, count = 2) {
        target.alpha = 1;
        const props = { loop: count * 2 - 1, bounce: true };
        createjs.Tween.get(target, props).to({ alpha: 0 }, 500);
    }


    next() {
        this.setPage(this._pageIndex + 1);
    }

    prev() {
        this.setPage(this._pageIndex - 1);
    }

    setPage(index) {
        this._pageIndex = Math.min(this._pageIds.length - 1, Math.max(0, index));

        const prefix = this._pageIds[this._pageIndex];
        const title = this.getText(prefix + ".title");
        const body = this.getText(prefix + ".body");
        this.setContent(title, body);

        this._updatePageButtons();

        this.stopNudges();
        if (this._forcingReadAll) {
            if (this._pageIndex == this._pageIds.length - 1) {
                this._allRead = true;
                this.enabled = true;
            }
            this.scheduleNudge();
        }
    }

    setContent(title, body) {
        const elems = [this._panel.bodyTextfield];

        if (!this._titleOrigHeight) {
            this._panel.nameTextfield.heightOrig = this._panel.nameTextfield.getMeasuredHeight();
            elems.forEach(elem => { elem.yOrig = elem.y; });
        }
        this._panel.nameTextfield.text = title;
        this._panel.bodyTextfield.text = body;
        const d = this._panel.nameTextfield.getMeasuredHeight() - this._panel.nameTextfield.heightOrig;
        elems.forEach(elem => { elem.y = elem.yOrig + d; });
    }

    _handlePrev() {
        this.prev();
    }
    _handleNext() {
        this.next();
    }
    _handlePageButton(e) {
        this.setPage(e.target.index);
    }

    _updatePageButtons() {
        this._buttonPrev.setEnabled(this._pageIndex > 0);
        this._buttonNext.setEnabled(this._pageIndex < this._pageIds.length - 1);

        if (this._state == State.OPENED) {
            this._buttonLayout.setSelected(this._pageIndex);
        } else {
            this._buttonLayout.setSelected(-1);
        }
    }

    _handleToggle(e) {
        this.stopNudges();
        if (this._state != State.OPENED) {
            this.open();
        } else {
            this.close();
        }
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._animateTo(this._openY, State.OPENED, instant);
            this.dispatchEvent(InfoPanelView.OPEN);
        }
    }
    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(this._closeY, State.CLOSED, instant);
            this.dispatchEvent(InfoPanelView.CLOSE);
        }
    }
    _animateTo(goalY, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
            this._toggle.setSelected(this._state != State.OPENED);
            this._updatePageButtons();
        }
        const alpha = stateAtEnd == State.OPENED ? 1 : 0;
        if (instant) {
            this._panel.y = goalY;
            this._target.bg.alpha = alpha;
            onComplete();
        } else {
            const dur = Math.abs(this._panel.y - goalY) * .5;
            createjs.Tween.get(this._panel).to({ y: goalY }, dur, createjs.Ease.quadOut).call(onComplete);
            createjs.Tween.get(this._target.bg).to({ alpha: alpha }, dur, createjs.Ease.quadOut);
        }
    }


}


const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

InfoPanelView.CLOSE = "InfoPanelView.CLOSE";
InfoPanelView.OPEN = "InfoPanelView.OPEN";